import './Rate.less'
import { Rate } from './Rate'

export type { RateProps } from './iRate'

export default Rate
